import { createAction, props } from '@ngrx/store';

import {
  BusinessProfileRequestRequest,
  DetailedBusinesses,
  UserBusiness,
  VerifyResponseEntry,
} from '@offconon/core-api';

export const verifyBusiness = createAction('[Workroom/Business/verify business] Verify Business');

export const getBusinessById = createAction(
  '[Workroom/Business/get business by id] Get Business By Id',
  props<{ businessId: number }>(),
);
export const getBusinessByIdSuccess = createAction(
  '[Workroom/Business/get business by id success] Get Business By Id Success',
  props<{ business: UserBusiness }>(),
);

export const updateVerifyBusiness = createAction(
  '[Workroom/Business/update verify business] Update Verify Business',
  props<{ verifyData: Partial<VerifyResponseEntry> }>(),
);

export const resetSelectedBusiness = createAction(
  '[Workroom/Business/reset selected business] Reset Selected Business',
);
export const updateSelectedBusiness = createAction(
  '[Workroom/Business/update selected business] Update Selected Business',
  props<{ business: Partial<UserBusiness> }>(),
);

export const setBusinessState = createAction(
  '[Workroom/Business/set business state] Set Business State',
  props<{ businessProfileRequestRequest: BusinessProfileRequestRequest }>(),
);

export const updateBusinessEntitySettings = createAction(
  '[Workroom/Business/update business entity settings] Update Business Entity Settings',
  props<{ businessProfileRequestRequest: BusinessProfileRequestRequest }>(),
);

export const updateBusinessEntitySettingsSuccess = createAction(
  '[Workroom/Business/update business entity settings success] Update Business Entity Settings Success',
  props<{ businessProfileRequestRequest: DetailedBusinesses }>(),
);
